import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetNotificationsCommand } from '@/app/notifications/commands/get-notifications.command'

const httpClient = new AxiosClient()

export const getNotificationsCommand = new GetNotificationsCommand(httpClient, store)
